import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../AuthModule/Login/Login";
import Layout from "../Template/LayoutMain/LayoutMain/Layout";
import InternetChecker from "../utils/InternetChecker/InternetChecker";
import ScrollToTop from "../utils/scrollToTop/ScrollToTop";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Bookings from "../Pages/Bookings/Bookings";
import MyQuote from "../Pages/MyQuote/MyQuote";
import Payment from "../Pages/Payment/Payment";
import Customer from "../Pages/Customer/Customer";
import Chats from "../Pages/Chats/Chats";
import { ChatDataProvider } from "../Context/chatDataContext";
import Services from "../Pages/Services/Services";
import ServicesPricingPage from "../Pages/Services/ServicesPricingPage/ServicesPricingPage";
import UploadGallery from "../Pages/Bookings/UploadGallery/UploadGallery";
import Subscribers from "../Pages/Subscribers/Subscribers";
import Photographer from "../Pages/Photographer/Photographer";
import PhotographerProfile from "../Pages/Photographer/PhotographerProfile/PhotographerProfile";
import Role from "../Pages/Role/Role";
import Commission from "../Pages/Commission/Commission";
import Staff from "../Pages/Staff/Staff";
import Queries from "../Pages/Queries/Queries";
import Promocode from "../Pages/Promocode/Promocode";
import ViewGalleryPhoto from "../Pages/Bookings/UploadGallery/ViewGalleryPhoto/ViewGalleryPhoto";
import JoinUs from "../Pages/JoinUs/JoinUs";
import ContactUs from "../Pages/ContactUs/ContactUs";
import GalleryPlans from "../Pages/GalleryPlans/GalleryPlans";
import Tickets from "../Pages/Tickets/Tickets";
import EditingGallery from "../Pages/Bookings/UpcomingEditingComponent/EditingGallery/EditingGallery";
import EditingViewGallery from "../Pages/Bookings/UpcomingEditingComponent/EditingViewGallery/EditingViewGallery";
import HourlyGallery from "../Pages/Bookings/UpcomingHourlyComponent/HourlyGallery/HourlyGallery";
import HourlyViewGallery from "../Pages/Bookings/UpcomingHourlyComponent/HourlyViewGallery/HourlyViewGallery";
const AppRoutes = () => {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  // ✅ UI-ONLY PRIVATE ROUTE
  const PrivateRoute = ({ children }) => {
    const isLoggedIn = sessionStorage.getItem("loggedIn") === "true";

    if (!isLoggedIn) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  return (
    <>
      <ScrollToTop />
      {isOffline && <InternetChecker />}

      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />
        {/* Protected Routes */}
        <Route
          element={
            <PrivateRoute>
              <ChatDataProvider>
                <Layout />
              </ChatDataProvider>
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/bookings/upload-gallery/:bookingId" element={<UploadGallery />} />
          <Route path="/bookings/editing-gallery/:bookingId" element={<EditingGallery />} />
          <Route path="/bookings/editing-view-gallery/:bookingId" element={<EditingViewGallery />} />
          <Route path="/bookings/hourly-gallery/:bookingId" element={<HourlyGallery />} />
          <Route path="/bookings/hourly-view-gallery/:bookingId" element={<HourlyViewGallery />} />
           <Route path="/bookings/view-gallery/:bookingId/:photographerId/:clientId" element={<ViewGalleryPhoto />} />
          <Route path="/queries" element={<Queries />} />
          <Route path="/my-quote" element={<MyQuote />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services-pricing/:serviceId" element={<ServicesPricingPage />} />
          <Route path="/gallery-plan" element={<GalleryPlans />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/photographer" element={<Photographer />} />
          <Route path="/photographer-profile/:photographerId" element={<PhotographerProfile />} />
          <Route path="/commission" element={<Commission />} />
          <Route path="/role" element={<Role />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/promocode" element={<Promocode />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/tickets" element={<Tickets />} />
          {/* /staff */}
          <Route path="/chat/booking/:bookingId" element={<Chats chatType="booking" />} />
          <Route path="/chat/quote/:quoteId" element={<Chats chatType="quote" />} />
           <Route path="/chat/queries/:quoteId" element={<Chats chatType="quote" />} />

        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};
export default AppRoutes;
